/* FDC cosmos: small space moments. Rocket on add to cart, a UFO that crosses the footer once per visit,
   an alien on empty filter results, and the hidden footer alien (easter egg).
   Everything is built on demand, uses transform/opacity only, and is skipped when the visitor prefers reduced motion. */
(() => {
  if (window.__fdcCosmos) return;
  window.__fdcCosmos = 1;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = (k, v) => { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (_) {} return null; };

  const ALIEN = '<svg viewBox="0 0 64 72" aria-hidden="true" focusable="false"><g stroke="#0b0a14" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M24 15 18 5M40 15 46 5" fill="none"/><circle cx="18" cy="5" r="3.2" fill="#d6ff3d"/><circle cx="46" cy="5" r="3.2" fill="#d6ff3d"/><path class="fdc-al__arm fdc-al__arm--l" d="M21 51 10 45 8 37" fill="none"/><path class="fdc-al__arm fdc-al__arm--r" d="M43 51 54 45 56 37" fill="none"/><path d="M20 45Q32 40 44 45L46 63Q32 69 18 63Z" fill="#8e6bff"/><ellipse cx="32" cy="28" rx="20" ry="17" fill="#d6ff3d"/></g><ellipse cx="24" cy="28" rx="5" ry="7.5" fill="#0b0a14" transform="rotate(-18 24 28)"/><ellipse cx="40" cy="28" rx="5" ry="7.5" fill="#0b0a14" transform="rotate(18 40 28)"/><circle cx="25.5" cy="25" r="1.6" fill="#fff"/><circle cx="41.5" cy="25" r="1.6" fill="#fff"/><path d="M28.5 37.5Q32 40 35.5 37.5" fill="none" stroke="#0b0a14" stroke-width="2" stroke-linecap="round"/></svg>';
  const UFO = '<svg viewBox="0 0 120 64" aria-hidden="true" focusable="false"><path d="M38 30a22 20 0 0 1 44 0Z" fill="rgba(142,107,255,.45)" stroke="#f5f2ea" stroke-width="2"/><circle cx="60" cy="22" r="6" fill="#d6ff3d"/><circle cx="57.6" cy="21" r="1.5" fill="#0b0a14"/><circle cx="62.4" cy="21" r="1.5" fill="#0b0a14"/><ellipse cx="60" cy="34" rx="54" ry="12" fill="#23212e" stroke="#f5f2ea" stroke-width="2"/><ellipse cx="60" cy="31" rx="40" ry="5" fill="#3a3848"/><circle class="fdc-flyby__l" cx="26" cy="36" r="3" fill="#d6ff3d"/><circle class="fdc-flyby__l" cx="60" cy="41" r="3" fill="#d6ff3d" style="animation-delay:.25s"/><circle class="fdc-flyby__l" cx="94" cy="36" r="3" fill="#d6ff3d" style="animation-delay:.5s"/></svg>';
  const ROCKET = '<svg viewBox="0 0 40 24" aria-hidden="true" focusable="false"><path class="fdc-rkt__flame" d="M9 12 1 7l3 5-3 5Z" fill="#ff8a3d"/><path d="M8 7h18c6 0 11 5 11 5s-5 5-11 5H8Z" fill="#f5f2ea" stroke="#0b0a14" stroke-width="2" stroke-linejoin="round"/><path d="M12 7 7 1h6l6 6M12 17l-5 6h6l6-6" fill="#8e6bff" stroke="#0b0a14" stroke-width="2" stroke-linejoin="round"/><circle cx="25" cy="12" r="2.6" fill="#d6ff3d" stroke="#0b0a14" stroke-width="1.6"/></svg>';

  const css = `
.fdc-rkt{position:fixed;left:0;top:0;width:34px;height:22px;margin:0;padding:0;border:0;background:none;overflow:visible;pointer-events:none;z-index:2147483000;inset:auto;will-change:transform,opacity}
.fdc-rkt svg{display:block;width:100%;height:100%;overflow:visible}
.fdc-rkt__flame{transform-origin:9px 12px;animation:fdcFlame .09s steps(2) infinite alternate}
@keyframes fdcFlame{to{transform:scaleX(1.5)}}
.fdc-cart-hit{animation:fdcHit .45s cubic-bezier(.3,1.6,.5,1)}
@keyframes fdcHit{40%{transform:scale(1.22) rotate(-8deg)}}
${reduce ? '' : 'fly-to-cart{display:none!important}'}
.fdc-flyby-sky{position:absolute;inset:0 0 auto 0;height:120px;overflow:hidden;pointer-events:none;z-index:1}
.fdc-flyby{position:absolute;left:0;top:18px;width:84px;will-change:transform}
.fdc-flyby svg{display:block;width:100%;height:auto;animation:fdcBob 1.6s ease-in-out infinite alternate}
.fdc-flyby__l{animation:fdcBlink .75s steps(2) infinite}
@keyframes fdcBob{to{transform:translateY(-8px) rotate(-3deg)}}
@keyframes fdcBlink{50%{opacity:.25}}
.fdc-nores{display:grid;justify-items:center;gap:10px;margin-bottom:6px}
.fdc-nores .fdc-al{width:84px;height:auto}
.fdc-al .fdc-al__arm{transform-box:fill-box}
.fdc-al--shrug .fdc-al__arm--l{transform-origin:100% 100%;animation:fdcShrugL 2.4s ease-in-out infinite}
.fdc-al--shrug .fdc-al__arm--r{transform-origin:0 100%;animation:fdcShrugR 2.4s ease-in-out infinite}
@keyframes fdcShrugL{0%,60%,100%{transform:none}70%,85%{transform:rotate(14deg) translateY(-2px)}}
@keyframes fdcShrugR{0%,60%,100%{transform:none}70%,85%{transform:rotate(-14deg) translateY(-2px)}}
.fdc-nores__btn{display:inline-block;padding:12px 22px;border-radius:99px;background:#0b0a14;color:#f5f2ea!important;font:600 14px "Space Grotesk",system-ui,sans-serif;text-decoration:none}
.fdc-nores__btn:hover{background:#d6ff3d;color:#0b0a14!important}
@media (prefers-reduced-motion:reduce){.fdc-al *,.fdc-flyby svg,.fdc-flyby__l{animation:none!important}}
`;
  const st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* 1. Rocket to the cart */
  const ADD = '.add-to-cart-button:not(.quick-add__button--choose), [data-fdc-add]';
  const visible = (el) => { const r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight; };
  function launch(from, cartEl) {
    const to = cartEl.getBoundingClientRect();
    const r = document.createElement('div');
    r.className = 'fdc-rkt';
    r.innerHTML = ROCKET;
    const canPop = typeof r.showPopover === 'function';
    if (canPop) r.setAttribute('popover', 'manual');
    document.body.appendChild(r);
    if (canPop) { try { r.showPopover(); } catch (_) {} }
    const x0 = from.left + from.width / 2, y0 = from.top + from.height / 2;
    const onScreen = to.width > 0 && to.bottom > 0 && to.top < innerHeight;
    const x2 = to.width > 0 ? to.left + to.width / 2 : innerWidth - 40, y2 = onScreen ? to.top + to.height / 2 : -40;
    const cx = (x0 + x2) / 2 + (x2 > x0 ? -60 : 60), cy = Math.min(y0, y2) - Math.min(220, Math.abs(y0 - y2) * .6 + 90);
    const frames = [], N = 24;
    for (let i = 0; i <= N; i++) {
      const t = i / N, u = 1 - t;
      const x = u * u * x0 + 2 * u * t * cx + t * t * x2, y = u * u * y0 + 2 * u * t * cy + t * t * y2;
      const dx = 2 * u * (cx - x0) + 2 * t * (x2 - cx), dy = 2 * u * (cy - y0) + 2 * t * (y2 - cy);
      const a = Math.atan2(dy, dx) * 180 / Math.PI;
      const s = t < .15 ? .6 + t / .15 * .6 : 1.2 - Math.max(0, t - .7) / .3 * .75;
      frames.push({ transform: `translate(${x - 17}px,${y - 11}px) rotate(${a}deg) scale(${s})`, opacity: t > .94 ? 0 : 1 });
    }
    const anim = r.animate(frames, { duration: 820, easing: 'cubic-bezier(.45,.05,.4,1)' });
    anim.onfinish = anim.oncancel = () => {
      r.remove();
      if (!onScreen) return;
      cartEl.classList.remove('fdc-cart-hit'); void cartEl.offsetWidth; cartEl.classList.add('fdc-cart-hit');
      setTimeout(() => cartEl.classList.remove('fdc-cart-hit'), 500);
    };
  }
  document.addEventListener('click', (e) => {
    if (reduce) return;
    const b = e.target.closest && e.target.closest(ADD);
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    const icons = [...document.querySelectorAll('cart-icon, .header-actions__cart-icon')];
    const cart = icons.find(visible) || icons[0];
    if (!cart) return;
    const from = b.getBoundingClientRect();
    requestAnimationFrame(() => launch(from, cart));
  }, true);

  /* 2. Alien on empty filter / search results (the grid re-renders when filters change) */
  function decorateEmpty(root) {
    (root || document).querySelectorAll('.main-collection-grid__empty:not([data-fdc])').forEach((box) => {
      box.setAttribute('data-fdc', '1');
      const u = new URL(location.href);
      const clear = new URL(u.pathname, u.origin);
      if (u.searchParams.get('q')) clear.searchParams.set('q', u.searchParams.get('q'));
      const hasFilters = [...u.searchParams.keys()].some((k) => k.startsWith('filter.'));
      const w = document.createElement('div');
      w.className = 'fdc-nores';
      w.innerHTML = '<span class="fdc-al fdc-al--shrug">' + ALIEN + '</span>';
      box.prepend(w);
      if (hasFilters) {
        const a = document.createElement('a');
        a.className = 'fdc-nores__btn';
        a.href = clear.pathname + clear.search;
        a.textContent = 'Clear filters';
        box.appendChild(a);
      }
    });
  }
  decorateEmpty();
  new MutationObserver((ms) => { for (const m of ms) if (m.addedNodes.length) { decorateEmpty(); break; } })
    .observe(document.body, { childList: true, subtree: true });

  /* 3. UFO crosses the footer, once per visit */
  const foot = document.querySelector('.fdc-foot');
  if (foot && !reduce && !store('fdcUfo') && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => {
      if (!es.some((x) => x.isIntersecting)) return;
      io.disconnect();
      store('fdcUfo', '1');
      setTimeout(() => {
        if (getComputedStyle(foot).position === 'static') foot.style.position = 'relative';
        const sky = document.createElement('div');
        sky.className = 'fdc-flyby-sky';
        sky.innerHTML = '<div class="fdc-flyby">' + UFO + '</div>';
        foot.prepend(sky);
        const u = sky.firstChild, W = foot.clientWidth;
        const a = u.animate([
          { transform: 'translate(-110px,14px)' },
          { transform: `translate(${W * .35}px,0)` },
          { transform: `translate(${W * .6}px,22px)` },
          { transform: `translate(${W + 110}px,-6px)` }
        ], { duration: W < 700 ? 5200 : 7800, easing: 'ease-in-out' });
        a.onfinish = a.oncancel = () => sky.remove();
      }, 500);
    }, { threshold: .2 });
    io.observe(foot);
  }

  /* 4. Hidden alien in the footer */
  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-fdc-egg], [data-fdc-egg-copy], [data-fdc-egg-close]');
    if (!t) return;
    const wrap = t.closest('.fdc-egg');
    const card = wrap && wrap.querySelector('.fdc-egg__card');
    if (!card) return;
    if (t.hasAttribute('data-fdc-egg')) {
      const open = card.hidden;
      card.hidden = !open;
      t.setAttribute('aria-expanded', String(open));
      wrap.classList.toggle('is-found', open);
    } else if (t.hasAttribute('data-fdc-egg-close')) {
      card.hidden = true;
      wrap.querySelector('[data-fdc-egg]').setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-found');
    } else {
      const code = t.getAttribute('data-fdc-egg-copy');
      const done = () => { t.textContent = 'Copied ✓'; setTimeout(() => (t.textContent = 'Copy'), 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    }
  });
})();
